<script setup>
import { Icon } from "@iconify/vue";

const props = defineProps({
  userOrId: {
    type: [Object, String, Number],
    required: false,
  },
  imageUrl: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    default: "40",
  },
  enableProfileDialog: {
    type: Boolean,
    default: true,
  },
});

const userStore = useUserStore();

const hasValidUserOrId = (userOrId) => {
  if (!userOrId) return false;

  if (typeof userOrId === "object") {
    if (Array.isArray(userOrId)) {
      return userOrId.length > 0;
    }

    return Object.keys(userOrId).length > 0;
  }

  if (typeof userOrId === "string") {
    return userOrId.trim().length > 0;
  }

  return true;
};

const onOpenProfile = () => {
  if (!props.enableProfileDialog || !hasValidUserOrId(props.userOrId)) return;
  openProfileDialog();
};

const openProfileDialog = () => {
  if (!hasValidUserOrId(props.userOrId)) return;
  userStore.openUserProfileDialog(props.userOrId);
};

defineExpose({
  openProfileDialog,
});
</script>

<template>
  <v-avatar
    class="tw-aspect-square"
    :class="{ 'tw-cursor-pointer': userOrId }"
    :size="size"
    color="surface"
    @click="onOpenProfile"
  >
    <v-img :src="imageUrl" v-if="imageUrl" />

    <!-- <v-icon v-else icon="mdi-user" color="primary" dark class="tw-w-full" /> -->
    <Icon v-else icon="mdi:user" class="tw-w-10/12 tw-h-auto"></Icon>
  </v-avatar>
</template>
